import { SpinnerGap } from "@phosphor-icons/react";
import { toAbsoluteUrl } from "../../components/_metronic/helpers";
import classes from "./Loading.module.css";

type Props = {
  show_image?: boolean;
  message?: string;
  messageSize?: string | number;
};

const Loading: React.FC<Props> = ({ show_image, message, messageSize }) => {
  return (
    <div className={classes.mainDiv}>
      {show_image && (
        <img
          src={toAbsoluteUrl("/media/logo_rpd/Riopele_Digital.svg")}
          alt="logo"
          width="260px"
          className="mb-15"
        />
      )}
      <SpinnerGap className={classes.icon} size={30} weight="bold" />
      {message && (
        <span
          className={classes.message}
          style={messageSize ? { fontSize: messageSize } : undefined}
        >
          {message}
        </span>
      )}
    </div>
  );
};
export default Loading;
